import { createApi } from '@reduxjs/toolkit/query/react';

import {
  ConsultingCompaniesPayload,
  ConsultingCompany,
} from '@/slices/consultingCompany/consultingCompany.types';

import { symfonyBaseQuery } from '@/services/SymfonyClient';

const consultingCompanyApi = createApi({
  baseQuery: symfonyBaseQuery({
    baseUrl: '/api/admin',
  }),
  reducerPath: 'consultingCompany',
  tagTypes: ['ConsultingCompany'],
  endpoints: (build) => ({
    getConsultingCompanies: build.query<ConsultingCompany[], void>({
      query: () => ({
        url: '/consulting-companies',
        method: 'GET',
      }),
      transformResponse: (response: ConsultingCompaniesPayload) =>
        response.consultingCompanies ?? [],
      providesTags: (result) => [
        { type: 'ConsultingCompany', id: 'LIST' },
        ...(result ?? []).map(({ id }) => ({
          type: 'ConsultingCompany' as const,
          id,
        })),
      ],
    }),
  }),
});

export default consultingCompanyApi;
